import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=352520bc&functional=true&"
import script from "./HeaderSection.vue?vue&type=script&lang=ts&"
export * from "./HeaderSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports